import { render, staticRenderFns } from "./SLRDayPayFlagPrepare.vue?vue&type=template&id=23424908&scoped=true&"
import script from "./SLRDayPayFlagPrepare.vue?vue&type=script&lang=ts&"
export * from "./SLRDayPayFlagPrepare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23424908",
  null
  
)

export default component.exports